module.exports = __webpack_public_path__ + "img/btn_TOEIC_practise_on.ef15b09a.png";